import React from 'react';
// services
import AuthService from 'src/services/AuthService';
// // next router
// import Router from 'next/router';
// cookie
import cookie from 'js-cookie';
// formik
import {useFormik} from 'formik';
// types
import {ISigninInputValues} from 'src/lib/types';
// material Ui
// import {makeStyles, createStyles, Theme} from '@mui/material/styles';
import {Paper, Button, TextField} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import {Box} from '@mui/material';
// import {url} from 'inspector';
import UsIndentureBg from '../../image/background-pattern.jpg';

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       flexGrow: 1,
//       margin: '10%',
//     },
//     paper: {
//       padding: theme.spacing(2),
//       margin: 'auto',
//       maxWidth: 425,
//     },
//     input: {
//       width: '100%',
//     },
//     signinBtn: {
//       marginTop: '15px',
//     },
//     label: {
//       fontSize: '11px',
//       color: '#3e3e3e',
//       marginBottom: '3px',
//       fontWeight: 700,
//       fontFamily: 'Roboto",sans-serif',
//     },
//     forgetPassword: {
//       color: '#0fb1ef',
//       fontSize: '12px',
//       float: 'right',
//     },
//   })
// );

interface IformikDefination {
  validateOnChange: boolean;
  validate?: any;
  handleSubmit: () => any;
  handleChange: (data: string) => any;
  values: ISigninInputValues;
  errors: any;
  resetForm: () => void;
}

function SignInForm() {
  // const classes = useStyles();
  const [openToaster, setOpenToaster] = React.useState(false);
  const [toast, setToast] = React.useState({error: ''});
  const handleToaster = () => {
    setOpenToaster(!openToaster);
  };
  const authService = new AuthService();
  const navigate = useNavigate();
  // formik
  const formik: IformikDefination = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validate: (values) => {
      formik.errors = {};
      setOpenToaster(false);

      if (!values.username) {
        formik.errors.email = 'Email is required';
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.username)) {
        formik.errors.email = 'Invalid email address';
      }

      if (!values.password) {
        formik.errors.password = 'Password is required';
      }
      return formik.errors;
    },
    validateOnChange: false,
    onSubmit: (values) => {
      AuthService.login(values)
        .then((res) => {
          authService.authenticateUser(res.token);
          cookie.set('username', values.username);
          // localStorage.setItem('token', res.token);
          // localStorage.setItem('username', values.username);
          // Router.push('/dashboard');
          navigate('/auth/signin');
        })
        .catch((err) => {
          console.log(err);

          setOpenToaster(true);
          setToast({error: 'Email / Password is Incorrect'});
        });
    },
  });
  React.useEffect(() => {
    if (cookie.get('accessToken')) {
      // Router.push('/dashboard');
      navigate('/');
    }
  });
  return (
    <div
    // className={classes.root}
    >
      <Box className="bondLoginContainer">
        <Paper className="bondLoginForm">
          <p className="bondLoginForm-p">Log In</p>
          <form onSubmit={formik.handleSubmit} noValidate autoComplete="off">
            {/* <p className={classes.label}>User ID</p> */}
            {formik.errors.email && (
              <div className="input-feedback" style={{color: 'red'}}>
                {formik.errors.email}
              </div>
            )}
            <TextField
              // className={classes.input}
              size="small"
              id="outlined-basic"
              autoComplete="off"
              placeholder="Email"
              value={formik.values.username}
              onChange={formik.handleChange('username')}
            />
            {/* <p className={classes.label}>Password</p> */}
            {formik.errors.password && (
              <div className="input-feedback" style={{color: 'red'}}>
                {formik.errors.password}
              </div>
            )}
            <TextField
              // className={classes.input}
              size="small"
              type="password"
              autoComplete="off"
              placeholder="Password"
              id="outlined-basic"
              value={formik.values.password}
              onChange={formik.handleChange('password')}
            />
            <span
            // className={classes.forgetPassword}
            >
              <a
                className=""
                href={'/forgetpassword'}
                target="_blank"
                rel="noreferrer"
                style={{
                  color: '#01b1ee!important',
                  fontSize: '12px',
                  display: 'flex',
                  justifyContent: 'end',
                  textDecoration: 'none',
                  marginBottom: '10px',
                }}
              >
                Forget password
              </a>
            </span>
            <Button
              type="submit"
              className="primary-btn"
              variant="contained"
              style={{width: '100%'}}
            >
              Login
            </Button>
          </form>
        </Paper>
        <Paper className="bondLoginLogo" style={{background: `url(${UsIndentureBg})`}}>
          <Box style={{textAlign: 'center', margin: '85px auto'}}>
            <img src="/ap-logo.png" alt="" />
          </Box>
        </Paper>
      </Box>
    </div>
  );
}
export default SignInForm;
